package com.pincer.app.viewmodel

import com.pincer.app.ApplicationState
import com.pincer.app.I18n
import com.pincer.core.model.tree.Answer
import com.pincer.core.model.tree.Participant
import com.pincer.core.model.tree.QuestionFormat
import com.pincer.core.model.tree.CHATS_SCOPE
import com.pincer.core.model.tree.PERMISSIONS_SCOPE
import com.pincer.core.model.tree.QUESTIONS_SCOPE
import com.pincer.core.model.tree.CANDIDATES_SCOPE
import com.pincer.core.model.tree.NAME_SCOPE
import com.pincer.core.model.tree.DESCRIPTION_SCOPE
import com.pincer.core.model.tree.RULES_SCOPE
import com.pincer.core.model.tree.PARTICIPANTS_SCOPE
import com.pincer.core.model.tree.PARTICIPANTS_ANSWERS_SCOPE
import com.pincer.core.model.tree.PARTICIPANTS_RULES_SCOPE
import com.pincer.core.model.tree.PARTICIPANTS_ROLES_SCOPE
import com.pincer.core.model.drafts.QuestionDraft
import com.pincer.core.model.drafts.AnswerDraft
import com.pincer.core.functions.termsNeeded
import com.pincer.core.functions.getAnswer
import com.pincer.core.functions.readable
import com.pincer.core.functions.readablePid
import com.pincer.core.functions.getRolesForParticipant
import com.pincer.core.functions.validateText
import com.pincer.core.functions.validateEmail
import com.pincer.core.functions.validateCode
import com.pincer.core.functions.validateQuestionCode
import com.pincer.core.functions.validateRegex
import com.pincer.core.functions.validateRoles
import com.pincer.core.functions.validateRole
import com.pincer.core.functions.validateOptions
import com.pincer.core.functions.validateAnswer
import com.pincer.core.functions.validateRules

fun pincerParticipants(state: ApplicationState, context: Node) {
    val localPincer = state.pincer()!!
    if (state.checkRead(PARTICIPANTS_SCOPE)) {
        val count = localPincer.participants.size
        context.node(key = "participants", summary = I18n.translate(if (count == 1) "participants-summary-one" else "participants-summary", count.toString())) {
            for (principalId in localPincer.participants.keys) {
                val participant = localPincer.participants[principalId]!!
                node(principalId, if (participant.name == null) principalId else participant.name!!) {
                    if (state.stored.showAdvancedOptionsAsBoolean()) {
                        if (state.checkRead(PARTICIPANTS_RULES_SCOPE)) {
                            node("redRules") {
                                node("value", participant.redRules)
                            }
                            node("greenRules") {
                                node("value", participant.greenRules)
                            }
                        }
                    }
                    if (state.checkRead(PARTICIPANTS_ROLES_SCOPE)) {
                        node("roles") {
                            node("value", participant.roles)
                        }
                    }
                    if (participant.answers.size > 0 && state.checkRead(PARTICIPANTS_ANSWERS_SCOPE)) {
                        node("answers") {
                            for (answerId in participant.answers.keys) {
                                val answer = participant.answers[answerId]!!
                                val question = localPincer.questions[answerId]
                                node(key = answerId, if (question != null) question.wording else answerId) {
                                    node("value", answer.wording)
                                }
                            }
                        }
                    }
                }
            }
        }
    }
}